module.exports = __webpack_public_path__ + "assets/media/lunch.248d0e70.mp3";